/**
 * Vehicle Selection Modal Component
 * Modal for selecting vehicle type
 */

import React from 'react';
import { Bus, CarFront, Car, Plane, Train, Ship, Bike, Footprints } from 'lucide-react';
import { VehicleType, VEHICLE_CONFIGS } from '../../types/matchdayPlanning';

const VEHICLE_ICON_MAP: Record<VehicleType, React.ReactNode> = {
  bus: <Bus size={18} />,
  minibus: <CarFront size={18} />,
  car: <Car size={18} />,
  plane: <Plane size={18} />,
  train: <Train size={18} />,
  taxi: <Car size={18} />,
  rentalcar: <CarFront size={18} />,
  ship: <Ship size={18} />,
  bicycle: <Bike size={18} />,
  onfoot: <Footprints size={18} />
};

interface VehicleSelectionModalProps {
  currentVehicle: VehicleType;
  onSelect: (vehicleType: VehicleType) => void;
  onClose: () => void;
}

const VehicleSelectionModal: React.FC<VehicleSelectionModalProps> = ({
  currentVehicle,
  onSelect,
  onClose
}) => {
  const handleSelect = (vehicleType: VehicleType) => {
    onSelect(vehicleType);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content vehicle-selection-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Verkehrsmittel auswählen</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          <div className="vehicle-grid">
            {Object.values(VEHICLE_CONFIGS).map((config) => (
              <div
                key={config.type}
                className={`vehicle-card ${currentVehicle === config.type ? 'selected' : ''}`}
                onClick={() => handleSelect(config.type)}
                style={{
                  borderColor: currentVehicle === config.type ? config.color : '#dee2e6',
                  backgroundColor: currentVehicle === config.type ? `${config.color}20` : 'white'
                }}
              >
                <div className="vehicle-name" style={{ color: config.color, fontWeight: 600, fontSize: '1.1rem' }}>
                  {VEHICLE_ICON_MAP[config.type]} {config.name}
                </div>
                {currentVehicle === config.type && (
                  <div className="selected-indicator" style={{ color: config.color }}>
                    ✓
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
};

export default VehicleSelectionModal;

